import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/lib/i18n";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const FLAG_CC: Record<string, string> = {
  en: "gb",
  el: "gr",
  es: "es",
  fr: "fr",
  de: "de",
  it: "it",
  ja: "jp",
};

function Flag({ code, className = "" }: { code: string; className?: string }) {
  const cc = FLAG_CC[code] || code;
  return (
    <img
      src={`https://flagcdn.com/w40/${cc}.png`}
      srcSet={`https://flagcdn.com/w80/${cc}.png 2x`}
      alt={`${cc} flag`}
      className={`inline-block rounded-[2px] shadow-sm object-cover ${className}`}
      loading="lazy"
    />
  );
}

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const base = (i18n.language || "en").split("-")[0];
  const current = LANGUAGES.find((l) => l.code === base) || LANGUAGES[0];

  const change = (code: string) => {
    i18n.changeLanguage(code);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="px-2 gap-1.5 md:gap-1.5 flex-col md:flex-row min-h-11 min-w-11 h-auto py-1"
          aria-label={`${t("publicChrome.language")}: ${current.label}`}
        >
          <Flag code={current.code} className="h-4 w-6" />
          <span className="md:hidden text-[9px] leading-none tracking-wide text-muted-foreground">{t("publicChrome.language")}</span>
          <span className="hidden md:inline text-xs uppercase font-semibold tracking-wide text-primary">{current.code}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => change(l.code)} className="gap-2">
            <Flag code={l.code} className="h-4 w-6" />
            <span className="flex-1">{l.label}</span>
            <span className="text-[10px] uppercase font-semibold text-muted-foreground">{l.code}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

